import { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { reservationBoardService } from '../services/reservation-system/reservation-board.service';
import { reservationBoardSharePath } from '../utils/reservationBoardSharePath.util';

/** 旧 URL（/reservations/:numericId）→ 共有 URL へリダイレクト */
export default function ReservationBoardLegacyRedirect() {
  const { boardId } = useParams<{ boardId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const raw = boardId?.trim() ?? '';
    if (!/^\d+$/.test(raw)) {
      navigate('/reservations', { replace: true });
      return;
    }
    const id = Number(raw);
    reservationBoardService
      .getBoard(id)
      .then((board) => {
        const path = reservationBoardSharePath(board.shareUrl);
        navigate(path ?? '/reservations', { replace: true });
      })
      .catch(() => {
        navigate('/reservations', { replace: true });
      });
  }, [boardId, navigate]);

  return (
    <div className="py-5 text-center">
      <Spinner animation="border" role="status" />
    </div>
  );
}
